/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actioninvalidenderror3Inputs */

const en_actioninvalidenderror3 = /** @type {(inputs: Actioninvalidenderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The action has to end after now and at the latest at 23:59 in six days.`)
};

const de_actioninvalidenderror3 = /** @type {(inputs: Actioninvalidenderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Aktion muss nach jetzt enden, spätestens in sechs Tagen um 23:59.`)
};

/**
* | output |
* | --- |
* | "The action has to end after now and at the latest at 23:59 in six days." |
*
* @param {Actioninvalidenderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actioninvalidenderror3 = /** @type {((inputs?: Actioninvalidenderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actioninvalidenderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actioninvalidenderror3(inputs)
	return de_actioninvalidenderror3(inputs)
});
export { actioninvalidenderror3 as "actionInvalidEndError" }